import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import React from 'react';
import { Feature } from '../../../Stars';
import { FeatureSet, FeatureBadge, FeatureLabel } from './partials';
export var ProductFeatures = function ProductFeatures(_ref) {
  var catalog = _ref.catalog,
    features = _ref.features,
    show = _ref.show;
  var featuresToShow = show.map(function (featureId) {
    var feature = features.find(function (item) {
      return item.alias === featureId;
    });
    var catalogFeature = catalog.find(function (item) {
      return item.alias === featureId;
    });
    if (feature) {
      return feature;
    }
    return catalogFeature ? {
      alias: featureId,
      name: catalogFeature.name,
      score: null
    } : null;
  }).filter(function (item) {
    return Boolean(item);
  });
  return React.createElement("div", null, featuresToShow.map(function (feature, index) {
    return React.createElement(FeatureSet, {
      key: index
    }, React.createElement(FeatureLabel, null, feature.name), React.createElement(FeatureBadge, null, React.createElement(Feature, {
      value: feature.score
    })));
  }));
};